import styles from "../creditreport.module.css";

const SkylineBar = ({ month, score, heightPct }) => {
    return (<div className={styles.skylineCol}>
        <div className={styles.bldg} style={{ height: `${heightPct}%` }}>
            <span className={styles.bldgScore}>{score}</span>
            <span className={styles.bldgDot} />
        </div>
        <p className={styles.skylineLabel}>{month}</p>
    </div>);
}

export default SkylineBar;